// Auto-generated by backend/generate_uiextra.py — 11-language UI strings.
export const UI_EXTRA = {
  "pkg.title": {
    "id": "Paket Umrah & Haji",
    "en": "Umrah & Hajj Packages",
    "ar": "باقات العمرة والحج",
    "fr": "Forfaits Omra & Hajj",
    "de": "Umrah & Hajj Pakete",
    "es": "Paquetes de Umrah y Hajj",
    "ru": "Пакеты Умры и Хаджа",
    "zh": "副朝与朝觐套餐",
    "ja": "ウムラ＆ハッジパッケージ",
    "ko": "우므라 & 하지 패키지",
    "hi": "उमरा और हज पैकेज"
  },
  "pkg.subtitle": {
    "id": "Rekomendasi travel Umrah & Haji bermanhaj Sunnah — bimbingan manasik sesuai tuntunan Rasulullah ﷺ.",
    "en": "Recommended Umrah & Hajj travel agency following the Sunnah methodology — manasik guidance in accordance with the teachings of Rasulullah ﷺ.",
    "ar": "وكالة سفر موصى بها للعمرة والحج وفق منهج السنة — إرشاد المناسك وفقاً لتعاليم رسول الله ﷺ.",
    "fr": "Agence de voyage recommandée pour la Omra et le Hajj selon la méthodologie Sunnah — guidance des manasik conformément aux enseignements de Rasulullah ﷺ.",
    "de": "Empfohlenes Umrah- & Hajj-Reisebüro nach der Sunnah-Methodik — Manasik-Anleitung gemäß den Lehren von Rasulullah ﷺ.",
    "es": "Agencia de viajes recomendada para Umrah y Hajj según la metodología Sunnah — orientación de manasik conforme a las enseñanzas de Rasulullah ﷺ.",
    "ru": "Рекомендуемое туристическое агентство для Умры и Хаджа по методологии Сунны — руководство манасик в соответствии с наставлениями Расулюллаха ﷺ.",
    "zh": "推荐遵循逊奈方法论的麦加小朝觐与朝觐旅行社——依照先知穆罕默德ﷺ的教导进行朝觐功课指导。",
    "ja": "スンナの方法論に従ったウムラ＆ハッジの旅行代理店を推薦 — ラスールッラーﷺの教えに従ったマナースィク指導。",
    "ko": "순나 방법론을 따르는 움라 & 하지 여행사 추천 — 라술룰라ﷺ의 가르침에 따른 마나시크 안내.",
    "hi": "सुन्नह पद्धति पर आधारित उमरा और हज के लिए अनुशंसित ट्रैवल एजेंसी — रसूलुल्लाह ﷺ की शिक्षाओं के अनुसार मनासिक मार्गदर्शन।"
  },
  "pkg.disclaimer": {
    "id": "Estimasi harga & durasi bersifat perkiraan. Kota keberangkatan umumnya dilayani; konfirmasikan ketersediaan & izin resmi (PPIU/PIHK) di Kemenag serta detail terbaru di website resmi operator.",
    "en": "Price & duration estimates are approximate. Departure cities are generally served; confirm availability & official permits (PPIU/PIHK) at Kemenag and the latest details on the operator's official website.",
    "ar": "تقديرات الأسعار والمدة تقريبية. مدن المغادرة تُخدم عمومًا؛ تأكد من التوفر والتصاريح الرسمية (PPIU/PIHK) في كيمناغ والتفاصيل الأخيرة على الموقع الرسمي للمشغّل.",
    "fr": "Les estimations de prix et de durée sont approximatives. Les villes de départ sont généralement desservies ; confirmez la disponibilité et les autorisations officielles (PPIU/PIHK) auprès du Kemenag et les derniers détails sur le site officiel de l'opérateur.",
    "de": "Preis- und Dauerangaben sind Schätzungen. Abflugstädte werden im Allgemeinen bedient; bestätigen Sie Verfügbarkeit und offizielle Genehmigungen (PPIU/PIHK) beim Kemenag sowie aktuelle Details auf der offiziellen Website des Anbieters.",
    "es": "Las estimaciones de precio y duración son aproximadas. Las ciudades de salida generalmente están disponibles; confirme la disponibilidad y los permisos oficiales (PPIU/PIHK) en Kemenag y los detalles más recientes en el sitio web oficial del operador.",
    "ru": "Оценки стоимости и продолжительности являются приблизительными. Города отправления, как правило, обслуживаются; подтвердите наличие мест и официальные разрешения (PPIU/PIHK) в Kemenag, а также актуальные сведения на официальном сайте оператора.",
    "zh": "价格与时长估算仅供参考。出发城市通常均有服务；请在Kemenag确认可用性及官方许可（PPIU/PIHK），并在运营商官方网站查阅最新详情。",
    "ja": "料金と所要時間の見積もりは概算です。出発都市は一般的に対応していますが、Kemenagで空き状況と公式許可（PPIU/PIHK）を確認し、最新の詳細はオペレーターの公式ウェブサイトでご確認ください。",
    "ko": "가격 및 기간 추정치는 대략적입니다. 출발 도시는 일반적으로 서비스가 제공됩니다; Kemenag에서 가용성 및 공식 허가(PPIU/PIHK)를 확인하고 최신 세부 정보는 운영사 공식 웹사이트에서 확인하십시오.",
    "hi": "मूल्य और अवधि अनुमान अनुमानित हैं। प्रस्थान शहर आमतौर पर सेवित होते हैं; Kemenag में उपलब्धता और आधिकारिक परमिट (PPIU/PIHK) की पुष्टि करें तथा नवीनतम विवरण ऑपरेटर की आधिकारिक वेबसाइट पर देखें।"
  },
  "pkg.country": {
    "id": "Negara",
    "en": "Country",
    "ar": "الدولة",
    "fr": "Pays",
    "de": "Land",
    "es": "País",
    "ru": "Страна",
    "zh": "国家",
    "ja": "国",
    "ko": "국가",
    "hi": "देश"
  },
  "pkg.city": {
    "id": "Kota",
    "en": "City",
    "ar": "مدينة",
    "fr": "Ville",
    "de": "Stadt",
    "es": "Ciudad",
    "ru": "Город",
    "zh": "城市",
    "ja": "都市",
    "ko": "도시",
    "hi": "शहर"
  },
  "pkg.sort": {
    "id": "Urutkan",
    "en": "Sort",
    "ar": "ترتيب",
    "fr": "Trier",
    "de": "Sortieren",
    "es": "Ordenar",
    "ru": "Сортировать",
    "zh": "排序",
    "ja": "並び替え",
    "ko": "정렬",
    "hi": "क्रमबद्ध करें"
  },
  "pkg.sortDefault": {
    "id": "Rekomendasi",
    "en": "Recommendations",
    "ar": "التوصيات",
    "fr": "Recommandations",
    "de": "Empfehlungen",
    "es": "Recomendaciones",
    "ru": "Рекомендации",
    "zh": "推荐",
    "ja": "おすすめ",
    "ko": "추천",
    "hi": "सिफारिशें"
  },
  "pkg.sortCheap": {
    "id": "Termurah",
    "en": "Cheapest",
    "ar": "الأرخص",
    "fr": "Le moins cher",
    "de": "Günstigste",
    "es": "Más barato",
    "ru": "Самый дешёвый",
    "zh": "最便宜",
    "ja": "最安値",
    "ko": "가장 저렴한",
    "hi": "सबसे सस्ता"
  },
  "pkg.sortExpensive": {
    "id": "Termahal",
    "en": "Most Expensive",
    "ar": "الأغلى",
    "fr": "Le Plus Cher",
    "de": "Am Teuersten",
    "es": "El Más Caro",
    "ru": "Самый Дорогой",
    "zh": "最贵的",
    "ja": "最も高価",
    "ko": "가장 비싼",
    "hi": "सबसे महंगा"
  },
  "pkg.verifiedOnly": {
    "id": "Hanya berizin resmi",
    "en": "Officially licensed only",
    "ar": "بتصريح رسمي فقط",
    "fr": "Avec licence officielle uniquement",
    "de": "Nur mit offizieller Genehmigung",
    "es": "Solo con licencia oficial",
    "ru": "Только с официальным разрешением",
    "zh": "仅限官方授权",
    "ja": "公式ライセンスのみ",
    "ko": "공식 허가만 해당",
    "hi": "केवल आधिकारिक लाइसेंस के साथ"
  },
  "pkg.all": {
    "id": "Semua",
    "en": "All",
    "ar": "الكل",
    "fr": "Tous",
    "de": "Alle",
    "es": "Todos",
    "ru": "Все",
    "zh": "全部",
    "ja": "すべて",
    "ko": "전체",
    "hi": "सभी"
  },
  "pkg.umrah": {
    "id": "Umrah",
    "en": "Umrah",
    "ar": "العمرة",
    "fr": "Omra",
    "de": "Umra",
    "es": "Umra",
    "ru": "Умра",
    "zh": "副朝",
    "ja": "ウムラ",
    "ko": "우므라",
    "hi": "उमरह"
  },
  "dash.favHint": {
    "id": "Akses cepat pilihan travel favorit Anda",
    "en": "Quick access to your favorite travel operators",
    "ar": "وصول سريع إلى وكالاتك المفضلة",
    "fr": "Accès rapide à vos agences favorites",
    "de": "Schneller Zugriff auf Ihre Favoriten-Anbieter",
    "es": "Acceso rápido a tus operadores favoritos",
    "ru": "Быстрый доступ к любимым операторам",
    "zh": "快速访问您收藏的旅行社",
    "ja": "お気に入りの旅行代理店にすばやくアクセス",
    "ko": "즐겨찾는 여행사에 빠르게 접근",
    "hi": "अपने पसंदीदा ट्रैवल तक त्वरित पहुँच"
  },
  "dash.favTitle": {
    "id": "Travel Favorit Saya",
    "en": "My Favorite Travels",
    "ar": "وكالاتي المفضلة",
    "fr": "Mes agences favorites",
    "de": "Meine Favoriten-Reisen",
    "es": "Mis viajes favoritos",
    "ru": "Мои избранные операторы",
    "zh": "我的收藏旅行社",
    "ja": "お気に入りの旅行代理店",
    "ko": "내 즐겨찾기 여행사",
    "hi": "मेरी पसंदीदा ट्रैवल"
  },
  "pkg.dashHint": {
    "id": "Pilihan paket perjalanan & fasilitasnya",
    "en": "Travel packages and their facilities",
    "ar": "باقات السفر ومرافقها",
    "fr": "Forfaits de voyage et leurs prestations",
    "de": "Reisepakete und ihre Leistungen",
    "es": "Paquetes de viaje y sus servicios",
    "ru": "Турпакеты и их услуги",
    "zh": "旅行套餐及设施",
    "ja": "旅行パッケージと設備",
    "ko": "여행 패키지 및 시설",
    "hi": "यात्रा पैकेज और उनकी सुविधाएँ"
  },
  "pkg.promo": {
    "id": "Promo/Terbatas",
    "en": "Promo / Limited",
    "ar": "عرض / محدود",
    "fr": "Promo / Limité",
    "de": "Aktion / Begrenzt",
    "es": "Promo / Limitado",
    "ru": "Акция / Ограничено",
    "zh": "促销 / 限量",
    "ja": "プロモ / 限定",
    "ko": "프로모션 / 한정",
    "hi": "प्रोमो / सीमित"
  },
  "pkg.promoFilter": {
    "id": "Promo",
    "en": "Promo",
    "ar": "عروض",
    "fr": "Promo",
    "de": "Aktion",
    "es": "Promo",
    "ru": "Акции",
    "zh": "促销",
    "ja": "プロモ",
    "ko": "프로모션",
    "hi": "प्रोमो"
  },
  "profile.duasSaved": {
    "id": "Doa favorit tersimpan",
    "en": "Saved favorite duas",
    "ar": "الأدعية المفضلة المحفوظة",
    "fr": "Invocations favorites enregistrées",
    "de": "Gespeicherte Lieblingsbittgebete",
    "es": "Súplicas favoritas guardadas",
    "ru": "Сохранённые любимые молитвы",
    "zh": "已保存的收藏祈祷",
    "ja": "保存したお気に入りの祈り",
    "ko": "저장한 즐겨찾기 두아",
    "hi": "सहेजी गई पसंदीदा दुआएँ"
  },
  "profile.history": {
    "id": "Riwayat Ibadah",
    "en": "Worship History",
    "ar": "سجل العبادة",
    "fr": "Historique des adorations",
    "de": "Anbetungsverlauf",
    "es": "Historial de adoración",
    "ru": "История поклонения",
    "zh": "功课记录",
    "ja": "礼拝の記録",
    "ko": "예배 기록",
    "hi": "इबादत इतिहास"
  },
  "profile.historyHint": {
    "id": "Ringkasan perjalanan ibadah Anda",
    "en": "A summary of your worship journey",
    "ar": "ملخص رحلة عبادتك",
    "fr": "Un résumé de votre parcours d'adoration",
    "de": "Eine Zusammenfassung Ihrer Anbetungsreise",
    "es": "Un resumen de tu recorrido de adoración",
    "ru": "Сводка вашего пути поклонения",
    "zh": "您的功课历程摘要",
    "ja": "あなたの礼拝の歩みのまとめ",
    "ko": "당신의 예배 여정 요약",
    "hi": "आपकी इबादत यात्रा का सारांश"
  },
  "profile.remove": {
    "id": "Hapus",
    "en": "Remove",
    "ar": "إزالة",
    "fr": "Retirer",
    "de": "Entfernen",
    "es": "Quitar",
    "ru": "Удалить",
    "zh": "移除",
    "ja": "削除",
    "ko": "삭제",
    "hi": "हटाएँ"
  },
  "profile.stagesDone": {
    "id": "Tahap manasik selesai",
    "en": "Manasik stages completed",
    "ar": "مراحل المناسك المكتملة",
    "fr": "Étapes du manasik terminées",
    "de": "Abgeschlossene Manasik-Etappen",
    "es": "Etapas del manasik completadas",
    "ru": "Завершённые этапы манасика",
    "zh": "已完成的仪式步骤",
    "ja": "完了したマナーシク段階",
    "ko": "완료한 마나식 단계",
    "hi": "पूर्ण मनासिक चरण"
  },
  "profile.ziyarahVisited": {
    "id": "Situs ziarah dikunjungi",
    "en": "Ziyarah sites visited",
    "ar": "مواقع الزيارة التي تمت زيارتها",
    "fr": "Sites de ziyarah visités",
    "de": "Besuchte Ziyarah-Stätten",
    "es": "Sitios de ziyarah visitados",
    "ru": "Посещённые места зиярата",
    "zh": "已参访的圣址",
    "ja": "訪れたジヤーラ聖地",
    "ko": "방문한 지야라 성지",
    "hi": "देखे गए ज़ियारा स्थल"
  },
  "promo.bannerBody": {
    "id": "Ada {n} paket sedang promo — jangan sampai terlewat!",
    "en": "{n} package(s) on promo right now — don't miss out!",
    "ar": "هناك {n} باقة في العرض الآن — لا تفوّتها!",
    "fr": "{n} forfait(s) en promo en ce moment — n'en manquez pas !",
    "de": "{n} Paket(e) gerade im Angebot — nicht verpassen!",
    "es": "¡{n} paquete(s) en promoción ahora — no te lo pierdas!",
    "ru": "Сейчас {n} пакет(ов) по акции — не упустите!",
    "zh": "现有 {n} 个套餐促销中——别错过！",
    "ja": "現在 {n} 件のパッケージがプロモ中——お見逃しなく！",
    "ko": "지금 {n}개 패키지 프로모션 중 — 놓치지 마세요!",
    "hi": "अभी {n} पैकेज प्रोमो पर — चूकें नहीं!"
  },
  "promo.bannerTitle": {
    "id": "Penawaran Promo & Terbatas",
    "en": "Promo & Limited Offers",
    "ar": "عروض وترويجات محدودة",
    "fr": "Offres promo et limitées",
    "de": "Promo- & Limitierte Angebote",
    "es": "Ofertas promo y limitadas",
    "ru": "Акции и ограниченные предложения",
    "zh": "促销与限量优惠",
    "ja": "プロモ・限定オファー",
    "ko": "프로모션 & 한정 특가",
    "hi": "प्रोमो और सीमित ऑफ़र"
  },
  "promo.view": {
    "id": "Lihat Promo",
    "en": "View Promos",
    "ar": "عرض العروض",
    "fr": "Voir les promos",
    "de": "Angebote ansehen",
    "es": "Ver promos",
    "ru": "Смотреть акции",
    "zh": "查看促销",
    "ja": "プロモを見る",
    "ko": "프로모션 보기",
    "hi": "प्रोमो देखें"
  },
  "pkg.hajj": {
    "id": "Haji",
    "en": "Hajj",
    "ar": "الحج",
    "fr": "Hajj",
    "de": "Haddsch",
    "es": "Hajj",
    "ru": "Хадж",
    "zh": "朝觐",
    "ja": "ハッジ",
    "ko": "하지",
    "hi": "हज"
  },
  "pkg.compare": {
    "id": "Bandingkan",
    "en": "Compare",
    "ar": "قارن",
    "fr": "Comparer",
    "de": "Vergleichen",
    "es": "Comparar",
    "ru": "Сравнить",
    "zh": "比较",
    "ja": "比較する",
    "ko": "비교하다",
    "hi": "तुलना करें"
  },
  "pkg.contactInfo": {
    "id": "Hubungi untuk info",
    "en": "Contact for info",
    "ar": "تواصل للحصول على معلومات",
    "fr": "Contactez pour des informations",
    "de": "Kontakt für Informationen",
    "es": "Contáctanos para más información",
    "ru": "Свяжитесь для получения информации",
    "zh": "联系获取信息",
    "ja": "情報についてお問い合わせください",
    "ko": "정보를 위해 연락하세요",
    "hi": "जानकारी के लिए संपर्क करें"
  },
  "pkg.verifiedBadge": {
    "id": "Berizin Resmi",
    "en": "Official License",
    "ar": "ترخيص رسمي",
    "fr": "Licence Officielle",
    "de": "Offizielle Lizenz",
    "es": "Licencia Oficial",
    "ru": "Официальная Лицензия",
    "zh": "官方许可证",
    "ja": "公式ライセンス",
    "ko": "공식 라이선스",
    "hi": "आधिकारिक लाइसेंस"
  },
  "pkg.checkKemenag": {
    "id": "Cek Izin Kemenag (SIMPU)",
    "en": "Check Kemenag Permit (SIMPU)",
    "ar": "التحقق من تصريح كيمناغ (SIMPU)",
    "fr": "Vérifier le Permis Kemenag (SIMPU)",
    "de": "Kemenag-Genehmigung prüfen (SIMPU)",
    "es": "Verificar Permiso Kemenag (SIMPU)",
    "ru": "Проверить разрешение Kemenag (SIMPU)",
    "zh": "检查宗教事务部许可（SIMPU）",
    "ja": "ケメナグ許可証を確認する（SIMPU）",
    "ko": "케메나그 허가 확인 (SIMPU)",
    "hi": "केमेनाग परमिट जांचें (SIMPU)"
  },
  "pkg.licenseNo": {
    "id": "No. Izin",
    "en": "No. Permission",
    "ar": "لا. إذن",
    "fr": "Non. Permission",
    "de": "Nein. Erlaubnis",
    "es": "No. Permiso",
    "ru": "Нет. Разрешение",
    "zh": "不。许可",
    "ja": "いいえ。許可",
    "ko": "아니요. 허가",
    "hi": "नहीं। अनुमति"
  },
  "pkg.days": {
    "id": "hari",
    "en": "day",
    "ar": "يوم",
    "fr": "jour",
    "de": "Tag",
    "es": "día",
    "ru": "день",
    "zh": "天",
    "ja": "日",
    "ko": "날",
    "hi": "दिन"
  },
  "pkg.website": {
    "id": "Website",
    "en": "Website",
    "ar": "الموقع الإلكتروني",
    "fr": "Site web",
    "de": "Website",
    "es": "Sitio web",
    "ru": "Веб-сайт",
    "zh": "网站",
    "ja": "ウェブサイト",
    "ko": "웹사이트",
    "hi": "वेबसाइट"
  },
  "pkg.ask": {
    "id": "Tanya",
    "en": "Question",
    "ar": "سؤال",
    "fr": "Question",
    "de": "Frage",
    "es": "Pregunta",
    "ru": "Вопрос",
    "zh": "问题",
    "ja": "質問",
    "ko": "질문",
    "hi": "प्रश्न"
  },
  "pkg.empty": {
    "id": "Belum ada paket tersedia saat ini.",
    "en": "No packages are available at this time.",
    "ar": "لا توجد باقات متاحة في الوقت الحالي.",
    "fr": "Aucun forfait n'est disponible pour le moment.",
    "de": "Derzeit sind keine Pakete verfügbar.",
    "es": "No hay paquetes disponibles en este momento.",
    "ru": "На данный момент пакеты недоступны.",
    "zh": "目前没有可用的套餐。",
    "ja": "現在利用可能なパッケージはありません。",
    "ko": "현재 이용 가능한 패키지가 없습니다.",
    "hi": "इस समय कोई पैकेज उपलब्ध नहीं है।"
  },
  "pkg.compareTitle": {
    "id": "Bandingkan Travel",
    "en": "Compare Travel",
    "ar": "مقارنة السفر",
    "fr": "Comparer les Voyages",
    "de": "Reisen Vergleichen",
    "es": "Comparar Viajes",
    "ru": "Сравнить Туры",
    "zh": "比较旅行",
    "ja": "旅行を比較する",
    "ko": "여행 비교",
    "hi": "यात्रा तुलना करें"
  },
  "pkg.type": {
    "id": "Tipe",
    "en": "Type",
    "ar": "النوع",
    "fr": "Type",
    "de": "Typ",
    "es": "Tipo",
    "ru": "Тип",
    "zh": "类型",
    "ja": "タイプ",
    "ko": "유형",
    "hi": "प्रकार"
  },
  "pkg.depCity": {
    "id": "Kota keberangkatan",
    "en": "City of Departure",
    "ar": "مدينة المغادرة",
    "fr": "Ville de départ",
    "de": "Abflugstadt",
    "es": "Ciudad de salida",
    "ru": "Город отправления",
    "zh": "出发城市",
    "ja": "出発都市",
    "ko": "출발 도시",
    "hi": "प्रस्थान शहर"
  },
  "pkg.license": {
    "id": "Izin resmi",
    "en": "Official permit",
    "ar": "تصريح رسمي",
    "fr": "Autorisation officielle",
    "de": "Offizielle Genehmigung",
    "es": "Permiso oficial",
    "ru": "Официальное разрешение",
    "zh": "官方许可",
    "ja": "公式許可証",
    "ko": "공식 허가증",
    "hi": "आधिकारिक अनुमति"
  },
  "pkg.estPrice": {
    "id": "Estimasi harga",
    "en": "Price Estimation",
    "ar": "تقدير السعر",
    "fr": "Estimation du prix",
    "de": "Preisschätzung",
    "es": "Estimación de precio",
    "ru": "Оценка стоимости",
    "zh": "价格估算",
    "ja": "価格見積もり",
    "ko": "가격 견적",
    "hi": "मूल्य अनुमान"
  },
  "pkg.hotelMakkah": {
    "id": "Hotel Makkah",
    "en": "Hotel Makkah",
    "ar": "فندق مكة",
    "fr": "Hôtel La Mecque",
    "de": "Hotel Mekka",
    "es": "Hotel La Meca",
    "ru": "Отель Мекка",
    "zh": "麦加酒店",
    "ja": "マッカホテル",
    "ko": "메카 호텔",
    "hi": "होटल मक्का"
  },
  "pkg.hotelMadinah": {
    "id": "Hotel Madinah",
    "en": "Hotel Madinah",
    "ar": "فندق المدينة",
    "fr": "Hôtel Madinah",
    "de": "Hotel Madinah",
    "es": "Hotel Madinah",
    "ru": "Отель Мадина",
    "zh": "麦地那酒店",
    "ja": "マディーナホテル",
    "ko": "마디나 호텔",
    "hi": "होटल मदीना"
  },
  "pkg.airline": {
    "id": "Maskapai",
    "en": "Airline",
    "ar": "شركة الطيران",
    "fr": "Compagnie aérienne",
    "de": "Fluggesellschaft",
    "es": "Aerolínea",
    "ru": "Авиакомпания",
    "zh": "航空公司",
    "ja": "航空会社",
    "ko": "항공사",
    "hi": "एयरलाइन"
  },
  "pkg.duration": {
    "id": "Durasi",
    "en": "Duration",
    "ar": "المدة",
    "fr": "Durée",
    "de": "Dauer",
    "es": "Duración",
    "ru": "Продолжительность",
    "zh": "时长",
    "ja": "所要時間",
    "ko": "소요 시간",
    "hi": "अवधि"
  },
  "pkg.info": {
    "id": "Info",
    "en": "Info",
    "ar": "معلومات",
    "fr": "Info",
    "de": "Info",
    "es": "Información",
    "ru": "Информация",
    "zh": "信息",
    "ja": "情報",
    "ko": "정보",
    "hi": "जानकारी"
  },
  "pkg.verified": {
    "id": "Berizin",
    "en": "Permit",
    "ar": "تصريح",
    "fr": "Permis",
    "de": "Genehmigung",
    "es": "Permiso",
    "ru": "Разрешение",
    "zh": "许可证",
    "ja": "許可証",
    "ko": "허가증",
    "hi": "अनुमति"
  },
  "pkg.notVerified": {
    "id": "Belum terverifikasi",
    "en": "Not verified",
    "ar": "غير موثق",
    "fr": "Non vérifié",
    "de": "Nicht verifiziert",
    "es": "No verificado",
    "ru": "Не верифицировано",
    "zh": "未经验证",
    "ja": "未確認",
    "ko": "미확인",
    "hi": "सत्यापित नहीं"
  },
  "pkg.checkSimpu": {
    "id": "Cek SIMPU",
    "en": "Check SIMPU",
    "ar": "تحقق من SIMPU",
    "fr": "Vérifier SIMPU",
    "de": "SIMPU überprüfen",
    "es": "Verificar SIMPU",
    "ru": "Проверить SIMPU",
    "zh": "检查 SIMPU",
    "ja": "SIMPUを確認する",
    "ko": "SIMPU 확인",
    "hi": "SIMPU जांचें"
  },
  "pkg.noData": {
    "id": "Belum ada data",
    "en": "No data available",
    "ar": "لا توجد بيانات",
    "fr": "Aucune donnée disponible",
    "de": "Keine Daten verfügbar",
    "es": "No hay datos disponibles",
    "ru": "Нет данных",
    "zh": "暂无数据",
    "ja": "データがありません",
    "ko": "데이터가 없습니다",
    "hi": "कोई डेटा उपलब्ध नहीं है"
  },
  "pkg.compareDisclaimer": {
    "id": "Data izin & harga bersifat perkiraan; konfirmasikan izin resmi (PPIU/PIHK) di Kemenag serta detail di website operator.",
    "en": "License & price data are approximate; confirm official permits (PPIU/PIHK) at Kemenag and details on the operator's website.",
    "ar": "بيانات الترخيص والأسعار تقريبية؛ تحقق من التصاريح الرسمية (PPIU/PIHK) في كيمناغ والتفاصيل على موقع المشغل.",
    "fr": "Les données de licence et de prix sont approximatives ; confirmez les autorisations officielles (PPIU/PIHK) auprès du Kemenag et les détails sur le site de l'opérateur.",
    "de": "Lizenz- und Preisdaten sind Näherungswerte; bestätigen Sie offizielle Genehmigungen (PPIU/PIHK) beim Kemenag und Details auf der Website des Betreibers.",
    "es": "Los datos de licencia y precio son aproximados; confirme los permisos oficiales (PPIU/PIHK) en Kemenag y los detalles en el sitio web del operador.",
    "ru": "Данные о лицензии и ценах являются приблизительными; подтвердите официальные разрешения (PPIU/PIHK) в Kemenag и детали на сайте оператора.",
    "zh": "许可证和价格数据为估算值；请在宗教事务部（Kemenag）确认正式许可（PPIU/PIHK），并在运营商网站核实详情。",
    "ja": "ライセンスと価格データは概算です。Kemenagで公式許可（PPIU/PIHK）を確認し、詳細はオペレーターのウェブサイトでご確認ください。",
    "ko": "라이선스 및 가격 데이터는 예상치입니다. Kemenag에서 공식 허가(PPIU/PIHK)를 확인하고 운영사 웹사이트에서 세부 사항을 확인하세요.",
    "hi": "लाइसेंस और मूल्य डेटा अनुमानित हैं; Kemenag में आधिकारिक परमिट (PPIU/PIHK) की पुष्टि करें और ऑपरेटर की वेबसाइट पर विवरण देखें।"
  },
  "pkg.selected": {
    "id": "dipilih",
    "en": "selected",
    "ar": "محدد",
    "fr": "sélectionné",
    "de": "ausgewählt",
    "es": "seleccionado",
    "ru": "выбрано",
    "zh": "已选择",
    "ja": "選択済み",
    "ko": "선택됨",
    "hi": "चयनित"
  },
  "pkg.max": {
    "id": "(maks)",
    "en": "(max)",
    "ar": "(الحد الأقصى)",
    "fr": "(max)",
    "de": "(max)",
    "es": "(máx)",
    "ru": "(макс)",
    "zh": "(最大)",
    "ja": "(最大)",
    "ko": "(최대)",
    "hi": "(अधिकतम)"
  },
  "certd.trigger": {
    "id": "Sertifikat PDF",
    "en": "PDF Certificate",
    "ar": "شهادة PDF",
    "fr": "Certificat PDF",
    "de": "PDF-Zertifikat",
    "es": "Certificado PDF",
    "ru": "PDF-сертификат",
    "zh": "PDF证书",
    "ja": "PDF証明書",
    "ko": "PDF 인증서",
    "hi": "PDF प्रमाणपत्र"
  },
  "certd.langLabel": {
    "id": "Bahasa sertifikat",
    "en": "Certificate Language",
    "ar": "لغة الشهادة",
    "fr": "Langue du certificat",
    "de": "Zertifikatssprache",
    "es": "Idioma del certificado",
    "ru": "Язык сертификата",
    "zh": "证书语言",
    "ja": "証明書の言語",
    "ko": "인증서 언어",
    "hi": "प्रमाणपत्र की भाषा"
  },
  "certd.guideLabel": {
    "id": "Nama pembimbing (tanda tangan)",
    "en": "Guide's name (signature)",
    "ar": "اسم المرشد (التوقيع)",
    "fr": "Nom du guide (signature)",
    "de": "Name des Führers (Unterschrift)",
    "es": "Nombre del guía (firma)",
    "ru": "Имя гида (подпись)",
    "zh": "导游姓名（签名）",
    "ja": "ガイドの名前（署名）",
    "ko": "가이드 이름 (서명)",
    "hi": "मार्गदर्शक का नाम (हस्ताक्षर)"
  },
  "certd.guidePlaceholder": {
    "id": "mis. Ust. Ahmad / nama travel",
    "en": "Ex. Ust. Ahmad / travel name",
    "ar": "مثال: أست. أحمد / اسم شركة السفر",
    "fr": "Ex. Ust. Ahmad / nom du voyage",
    "de": "Bsp. Ust. Ahmad / Reisename",
    "es": "Ej. Ust. Ahmad / nombre del viaje",
    "ru": "Напр. Уст. Ахмад / название тура",
    "zh": "例：Ust. Ahmad / 旅行社名称",
    "ja": "例：Ust. Ahmad / 旅行会社名",
    "ko": "예: Ust. Ahmad / 여행사 이름",
    "hi": "उदा. Ust. Ahmad / यात्रा नाम"
  },
  "certd.generate": {
    "id": "Buat Sertifikat PDF",
    "en": "Create PDF Certificate",
    "ar": "إنشاء شهادة PDF",
    "fr": "Créer un certificat PDF",
    "de": "PDF-Zertifikat erstellen",
    "es": "Crear certificado PDF",
    "ru": "Создать PDF-сертификат",
    "zh": "创建PDF证书",
    "ja": "PDF証明書を作成する",
    "ko": "PDF 인증서 만들기",
    "hi": "PDF प्रमाणपत्र बनाएं"
  },
  "certd.none": {
    "id": "Tandai minimal satu situs sebagai dikunjungi untuk membuat sertifikat.",
    "en": "Mark at least one site as visited to generate a certificate.",
    "ar": "ضع علامة على موقع واحد على الأقل باعتباره مُزارًا لإنشاء الشهادة.",
    "fr": "Marquez au moins un site comme visité pour générer un certificat.",
    "de": "Markieren Sie mindestens eine Stätte als besucht, um ein Zertifikat zu erstellen.",
    "es": "Marca al menos un sitio como visitado para generar un certificado.",
    "ru": "Отметьте хотя бы одно место как посещённое, чтобы создать сертификат.",
    "zh": "将至少一个地点标记为已访问，以生成证书。",
    "ja": "証明書を作成するには、少なくとも1か所の訪問済みサイトをマークしてください。",
    "ko": "인증서를 생성하려면 최소 한 곳의 사이트를 방문한 것으로 표시하세요.",
    "hi": "प्रमाणपत्र बनाने के लिए कम से कम एक स्थल को विज़िट किया हुआ चिह्नित करें।"
  },
  "pkg.price": {
    "id": "Harga",
    "en": "Price",
    "ar": "السعر",
    "fr": "Prix",
    "de": "Preis",
    "es": "Precio",
    "ru": "Цена",
    "zh": "价格",
    "ja": "価格",
    "ko": "가격",
    "hi": "कीमत"
  },
  "pkg.favorite": {
    "id": "Favorit",
    "en": "Favorites",
    "ar": "المفضلة",
    "fr": "Favoris",
    "de": "Favoriten",
    "es": "Favoritos",
    "ru": "Избранное",
    "zh": "收藏夹",
    "ja": "お気に入り",
    "ko": "즐겨찾기",
    "hi": "पसंदीदा"
  },
  "pkg.favorites": {
    "id": "Favorit Saya",
    "en": "My Favorites",
    "ar": "المفضلة لديّ",
    "fr": "Mes Favoris",
    "de": "Meine Favoriten",
    "es": "Mis Favoritos",
    "ru": "Мои Избранные",
    "zh": "我的收藏",
    "ja": "お気に入り",
    "ko": "내 즐겨찾기",
    "hi": "मेरे पसंदीदा"
  },
  "pkg.saved": {
    "id": "Tersimpan",
    "en": "Saved",
    "ar": "محفوظ",
    "fr": "Enregistré",
    "de": "Gespeichert",
    "es": "Guardado",
    "ru": "Сохранено",
    "zh": "已保存",
    "ja": "保存済み",
    "ko": "저장됨",
    "hi": "सहेजा गया"
  },
  "pkg.recommended": {
    "id": "Rekomendasi Saudi (Nusuk)",
    "en": "Saudi Recommendation (Nusuk)",
    "ar": "التوصية السعودية (نسك)",
    "fr": "Recommandation Saoudienne (Nusuk)",
    "de": "Saudi-Empfehlung (Nusuk)",
    "es": "Recomendación Saudí (Nusuk)",
    "ru": "Саудовская рекомендация (Нусук)",
    "zh": "沙特推荐（Nusuk）",
    "ja": "サウジのおすすめ（Nusuk）",
    "ko": "사우디 추천 (Nusuk)",
    "hi": "सऊदी अनुशंसा (Nusuk)"
  },
  "pkg.recommendedFilter": {
    "id": "Rekomendasi Saudi",
    "en": "Saudi Recommendations",
    "ar": "التوصيات السعودية",
    "fr": "Recommandations Saoudiennes",
    "de": "Saudi-Empfehlungen",
    "es": "Recomendaciones Sauditas",
    "ru": "Рекомендации Саудовской Аравии",
    "zh": "沙特建议",
    "ja": "サウジのおすすめ",
    "ko": "사우디 추천",
    "hi": "सऊदी सिफारिशें"
  },
  "pkg.shareCompare": {
    "id": "Bagikan (WhatsApp)",
    "en": "Share (WhatsApp)",
    "ar": "مشاركة (واتساب)",
    "fr": "Partager (WhatsApp)",
    "de": "Teilen (WhatsApp)",
    "es": "Compartir (WhatsApp)",
    "ru": "Поделиться (WhatsApp)",
    "zh": "分享 (WhatsApp)",
    "ja": "共有 (WhatsApp)",
    "ko": "공유 (WhatsApp)",
    "hi": "साझा करें (WhatsApp)"
  },
  "pkg.recommendedTip": {
    "id": "Terdaftar & terintegrasi dengan platform resmi Nusuk (Arab Saudi) serta berizin resmi Kemenag.",
    "en": "Registered & integrated with the official Nusuk platform (Saudi Arabia) and officially licensed by the Ministry of Religious Affairs.",
    "ar": "مسجّل ومتكامل مع منصة نُسُك الرسمية (المملكة العربية السعودية) وحاصل على ترخيص رسمي من وزارة الشؤون الدينية.",
    "fr": "Enregistré et intégré à la plateforme officielle Nusuk (Arabie Saoudite) et officiellement agréé par le Ministère des Affaires Religieuses.",
    "de": "Registriert und integriert mit der offiziellen Nusuk-Plattform (Saudi-Arabien) und offiziell lizenziert vom Ministerium für Religiöse Angelegenheiten.",
    "es": "Registrado e integrado con la plataforma oficial Nusuk (Arabia Saudita) y con licencia oficial del Ministerio de Asuntos Religiosos.",
    "ru": "Зарегистрирован и интегрирован с официальной платформой Nusuk (Саудовская Аравия) и имеет официальную лицензию Министерства по делам религий.",
    "zh": "已在沙特阿拉伯官方Nusuk平台注册并完成整合，同时获得宗教事务部正式授权许可。",
    "ja": "サウジアラビアの公式Nusukプラットフォームに登録・統合され、宗教省から正式にライセンスを取得しています。",
    "ko": "사우디아라비아 공식 Nusuk 플랫폼에 등록 및 통합되었으며, 종교부로부터 공식 허가를 받았습니다.",
    "hi": "सऊदी अरब के आधिकारिक Nusuk प्लेटफ़ॉर्म के साथ पंजीकृत एवं एकीकृत, तथा धार्मिक मामलों के मंत्रालय से आधिकारिक रूप से लाइसेंस प्राप्त।"
  },
  "pkg.noFav": {
    "id": "Belum ada travel favorit. Ketuk ikon hati pada kartu untuk menyimpan.",
    "en": "No favorite travels yet. Tap the heart icon on the card to save.",
    "ar": "لا توجد رحلات مفضلة بعد. اضغط على أيقونة القلب على البطاقة للحفظ.",
    "fr": "Pas encore de voyages favoris. Appuyez sur l'icône cœur sur la carte pour enregistrer.",
    "de": "Noch keine Lieblingsreisen. Tippe auf das Herz-Symbol auf der Karte, um zu speichern.",
    "es": "Aún no hay viajes favoritos. Toca el ícono de corazón en la tarjeta para guardar.",
    "ru": "Избранных туров пока нет. Нажмите на значок сердца на карточке, чтобы сохранить.",
    "zh": "暂无收藏的旅行。点击卡片上的心形图标即可保存。",
    "ja": "お気に入りの旅行はまだありません。カードのハートアイコンをタップして保存してください。",
    "ko": "아직 즐겨찾는 여행이 없습니다. 카드의 하트 아이콘을 탭하여 저장하세요.",
    "hi": "अभी तक कोई पसंदीदा यात्रा नहीं है। सहेजने के लिए कार्ड पर दिल के आइकन पर टैप करें।"
  },
  "pkg.filters": {
    "id": "Filter & Urutkan",
    "en": "Filter & Sort",
    "ar": "تصفية وترتيب",
    "fr": "Filtrer et trier",
    "de": "Filtern & Sortieren",
    "es": "Filtrar y ordenar",
    "ru": "Фильтр и сортировка",
    "zh": "筛选与排序",
    "ja": "フィルターと並べ替え",
    "ko": "필터 및 정렬",
    "hi": "फ़िल्टर और क्रमबद्ध करें"
  },
  "pkg.results": {
    "id": "{n} travel ditemukan",
    "en": "{n} travel found",
    "ar": "تم العثور على {n} رحلة",
    "fr": "{n} voyage trouvé",
    "de": "{n} Reise gefunden",
    "es": "{n} viaje encontrado",
    "ru": "Найдено {n} путешествий",
    "zh": "找到 {n} 个行程",
    "ja": "{n} 件のトラベルが見つかりました",
    "ko": "{n}개의 여행이 발견되었습니다",
    "hi": "{n} यात्रा मिली"
  },
  "pkg.loadMore": {
    "id": "Muat lebih banyak",
    "en": "Load more",
    "ar": "تحميل المزيد",
    "fr": "Charger plus",
    "de": "Mehr laden",
    "es": "Cargar más",
    "ru": "Загрузить ещё",
    "zh": "加载更多",
    "ja": "もっと読み込む",
    "ko": "더 불러오기",
    "hi": "और लोड करें"
  },
  "pkg.activeFilters": {
    "id": "{n} aktif",
    "en": "{n} active",
    "ar": "{n} نشط",
    "fr": "{n} actif",
    "de": "{n} aktiv",
    "es": "{n} activo",
    "ru": "{n} активных",
    "zh": "{n} 活跃",
    "ja": "{n} アクティブ",
    "ko": "{n} 활성",
    "hi": "{n} सक्रिय"
  }
};
